import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Header, Radio, Input } from 'semantic-ui-react';
import Amounts from './amounts';

import './styles.css';

class ContributionSelector extends Component {
  static propTypes = {
    fieldChangeHandler: PropTypes.func.isRequired,
    member: PropTypes.object,
    padTop: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      otherClicked: false,
    };
  }

  otherRadioChangeHandler = (_, data) => {
    const { fieldChangeHandler } = this.props;
    this.setState({
      otherClicked: true,
    });
    fieldChangeHandler(null, { name: 'contributionAmount', value: 0 });
  }

  otherFieldChangeHandler = (_, data) => {
    const { fieldChangeHandler } = this.props;
    fieldChangeHandler(null, { name: 'contributionAmount', value: data.value });
  }

  fieldChangeHandler = (_, data) => {
    const { fieldChangeHandler } = this.props;
    this.setState({
      otherClicked: false,
    });
    fieldChangeHandler(_, data);
  }

  render() {
    const { member, padTop } = this.props;
    const { otherClicked } = this.state;

    return (
      <div styleName={padTop ? 'pad-top' : ''}>
        <Header as="h3" dividing>
          Contribution for AARP Foundation
          <Header.Subheader>
            You can also contribute to the <a href="http://www.aarp.org/foundation/" target="new">AARP Foundation</a> in support of their work to help older adults age with independence and dignity with a tax-deductible gift in the amount of: {/* eslint-disable-line max-len */}
          </Header.Subheader>
        </Header>
        <div className="ui grid">
          <div className="wide column">
            <Radio
              key="ANONE"
              styleName="amount-radio"
              label="None"
              name="contributionAmount"
              value=""
              checked={member.contributionAmount === ''}
              onChange={this.fieldChangeHandler}
            />
            {
              Amounts.map(amount => (
                <Radio
                  key={amount.id}
                  styleName="amount-radio"
                  label={amount.label}
                  name="contributionAmount"
                  value={amount.value}
                  checked={member.contributionAmount === amount.value}
                  onChange={this.fieldChangeHandler}
                />
              ))
            }
            <Radio
              key="AOTHER"
              styleName="amount-radio"
              name="contributionAmount"
              checked={otherClicked}
              onChange={this.otherRadioChangeHandler}
            />
            <Input
              label="$"
              styleName="amount-field"
              value={otherClicked ? member.contributionAmount : '0'}
              onChange={this.otherFieldChangeHandler}
              disabled={!otherClicked}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ContributionSelector;



// WEBPACK FOOTER //
// ./src/app/components/Contribution/index.js